export default __webpack_public_path__ + "static/media/Thumb_Facial_Hair_05.83ef7ff7.png";